require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-this-code-fellows-alum-wanted-an-app-so-he-learned-to-code-and-built-it-himself.json") })
        }
      }, "path---blog-this-code-fellows-alum-wanted-an-app-so-he-learned-to-code-and-built-it-himself");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-this-code-fellows-alum-wanted-an-app-so-he-learned-to-code-and-built-it-himself!./.cache/json/blog-this-code-fellows-alum-wanted-an-app-so-he-learned-to-code-and-built-it-himself.json
// module id = 1095
// module chunks = 231608221292675